'use client';

import { c as _c } from "react/compiler-runtime";
import { Icon, Image, TextPassage } from '@petsmart-ui/sparky';
import cn from 'classnames';
import Link from 'next/link';
import { getStoreDisplayTime, storeIsOpen, usePageLayout } from '@libs/common-next';
import type { StoreService, StoreV2 } from '@libs/common-types';
import { handleServiceClick } from '@libs/experience-api';
import { constructServiceURL, serviceImages, VETERINARY } from '@/utils/storeDetailsServicesModule';
type StoreDetailsServiceLinkProps = {
  currentDate: Date;
  shouldHideVetHours: boolean;
  service: StoreService;
  store: StoreV2;
};
export function StoreDetailsServiceLink(t0) {
  const $ = _c(36);
  const {
    currentDate,
    shouldHideVetHours,
    service,
    store
  } = t0;
  const {
    isAuthenticated
  } = usePageLayout();
  let t1;
  if ($[0] !== service.ServiceName) {
    t1 = service.ServiceName.toLowerCase();
    $[0] = service.ServiceName;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const isVeterinary = t1 === VETERINARY;
  const shouldSuppressHours = shouldHideVetHours && isVeterinary;
  let serviceDisplayTime;
  let t2;
  if ($[2] !== currentDate || $[3] !== service.StandardStoreServiceHours || $[4] !== shouldSuppressHours || $[5] !== store) {
    const modifiedService = {
      ...store,
      StandardStoreHours: service.StandardStoreServiceHours
    };
    serviceDisplayTime = shouldSuppressHours ? undefined : getStoreDisplayTime(modifiedService, currentDate);
    t2 = shouldSuppressHours ? undefined : storeIsOpen(modifiedService, currentDate);
    $[2] = currentDate;
    $[3] = service.StandardStoreServiceHours;
    $[4] = shouldSuppressHours;
    $[5] = store;
    $[6] = serviceDisplayTime;
    $[7] = t2;
  } else {
    serviceDisplayTime = $[6];
    t2 = $[7];
  }
  const isStoreOpen = t2;
  let t3;
  if ($[8] !== service || $[9] !== store) {
    t3 = constructServiceURL(service, store) ?? "";
    $[8] = service;
    $[9] = store;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const serviceUrl = t3;
  let t4;
  if ($[11] !== isAuthenticated || $[12] !== isVeterinary || $[13] !== serviceUrl) {
    t4 = async event => await handleServiceClick({
      authType: isAuthenticated,
      event,
      link: serviceUrl,
      shouldOpenInNewTab: isVeterinary
    });
    $[11] = isAuthenticated;
    $[12] = isVeterinary;
    $[13] = serviceUrl;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  const t5 = serviceImages[service.ServiceName] ?? "";
  const t6 = `${service.ServiceName} image`;
  let t7;
  if ($[15] !== t5 || $[16] !== t6) {
    t7 = <Image src={t5} alt={t6} width={60} height={60} />;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  const t8 = shouldSuppressHours && "store-details-services__info--centered";
  let t9;
  if ($[18] !== t8) {
    t9 = cn("store-details-services__info", t8);
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  const t10 = isVeterinary ? "Veterinary Care" : service.ServiceName;
  let t11;
  if ($[20] !== t10) {
    t11 = <TextPassage size="lg">{t10}</TextPassage>;
    $[20] = t10;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== isStoreOpen || $[23] !== serviceDisplayTime || $[24] !== shouldSuppressHours) {
    t12 = !shouldSuppressHours && <TextPassage className={`store-details-hours__info--${isStoreOpen ? "open" : "closed"}`}>{serviceDisplayTime}</TextPassage>;
    $[22] = isStoreOpen;
    $[23] = serviceDisplayTime;
    $[24] = shouldSuppressHours;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t11 || $[27] !== t12 || $[28] !== t9) {
    t13 = <div className={t9}>{t11}{t12}</div>;
    $[26] = t11;
    $[27] = t12;
    $[28] = t9;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <Icon name="chevron-right" size="lg" />;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== serviceUrl || $[32] !== t13 || $[33] !== t4 || $[34] !== t7) {
    t15 = <Link className="store-details-services__link" href={serviceUrl} onClick={t4} prefetch={false} target="_blank" tabIndex={0}>{t7}{t13}{t14}</Link>;
    $[31] = serviceUrl;
    $[32] = t13;
    $[33] = t4;
    $[34] = t7;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  return t15;
}